import { createAsyncThunk } from '@reduxjs/toolkit';
import { patchUpdateDefectListAsDeleted } from 'scenes/DefectList/services/patch-update-defect-list-as-deleted.service';
import { selectSelectedDefectList } from '../selectors/defect-list.selectors';

export const deleteDefectList = createAsyncThunk(
  'defectLists/deleteDefectList',
  async (_, { getState }) => {
    const selectedDefectList = selectSelectedDefectList(getState());

    console.log('SELECTED DEFECT LIST', selectedDefectList);

    const deletedDefectListData = await patchUpdateDefectListAsDeleted(
      selectedDefectList.projectId,
      selectedDefectList.id
    );

    return deletedDefectListData;
  }
);
